import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const handleAddAlert = createAsyncThunk("Alerts/handleAddAlert", async (data, thunkAPI) => {
  try {
    const resp = await axios.post(`${process.env.REACT_APP_BASE_URL}api/events-alerts-v2/alerts`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return {...resp.data.data,schedule:data.schedule};
  } catch (error) {
    if (error.response) {
      return thunkAPI.rejectWithValue(error.response.data.errorMessage || error.response.data.message);
    } else {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
});
